import _ from 'lodash';
import { ISource } from '@wix/media-platform-js-client/dist/mjs/src/platform/management/job/source';
import { createSelector } from 'reselect';

import { MediaAsset, UploadingFile } from '../../types/media-assets';
import { MaybeUndef, StringMap } from '../../types/system';
import { normalize } from '../../utils/path/path';
import { StoreState } from '../reducers/store.types';

import { FilesRootState } from './files-root.reducer';
import { FilesState } from './files.reducer';

export const getFilesRoot = (state: StoreState): FilesRootState =>
  state.filesRoot;

export const getMediaAssetsMap = createSelector(
  getFilesRoot,
  (state: FilesRootState): FilesState => state.files,
);

export const getAllUploadingFiles = createSelector(
  getFilesRoot,
  (state: FilesRootState): UploadingFile[] => state.uploading,
);

export const findMediaAssetByPath = (
  state: StringMap<MediaAsset>,
  path: string,
): MaybeUndef<MediaAsset> => {
  const nPath = normalize(path);
  return _.find(state, (file: MediaAsset) => {
    return normalize(file.path) === nPath;
  });
};

export const getFilePathById = (
  state: StoreState,
  fileId: string,
): MaybeUndef<string> => {
  const file: MaybeUndef<MediaAsset> = _.find(getMediaAssetsMap(state), {
    id: fileId,
  });

  return file && file.path;
};

export const getFileIdByPath = (
  state: StoreState,
  path: string,
): MaybeUndef<string> => {
  const file: MaybeUndef<MediaAsset> = findMediaAssetByPath(
    getMediaAssetsMap(state),
    path,
  );
  return file && file.id;
};

export function findAssetsBySource(
  state: StringMap<MediaAsset>,
  source: ISource,
): MaybeUndef<MediaAsset> {
  if (source.fileId) {
    return state[source.fileId];
  }

  if (source.path) {
    return findMediaAssetByPath(state, source.path);
  }

  return;
}
